import { Service } from './';

export class AccountService extends Service {

  static entity: string = '/api/account';

  static getMyProfile(): Promise<any> {
    return this.axios.get(`${this.entity}/my-profile`).then(res => res.data);
  }

  static changePassword(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/my-profile/change-password`, data).then(res => res.data);
  }

}
